import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

// Legacy shape preserved so existing deep links keep their year + map
// the old `?tab=overview|goals` onto the new path-based tab.
const legacySearchSchema = z.object({
  tab: z.enum(['overview', 'goals']).optional(),
  year: z.coerce.number().int().optional(),
});

export const Route = createFileRoute('/$orgPid/revenue')({
  validateSearch: legacySearchSchema,
  beforeLoad: ({ params, search }) => {
    // Both tabs are one page now (#205); the old goals tab opens it for editing.
    const edit = search.tab === 'goals';
    // Clamp to the parent route's allowed range so an out-of-range legacy
    // ?year= can't crash the redirect target's validateSearch.
    const currentYear = new Date().getFullYear();
    const minYear = 2020;
    const maxYear = currentYear + 5;
    const requested = search.year ?? currentYear;
    const clampedYear = Math.min(maxYear, Math.max(minYear, requested));
    throw redirect({
      to: '/$orgPid/analytics/goals',
      params,
      search: { year: clampedYear, boatPid: 'all', ...(edit ? { edit: true } : {}) },
    });
  },
});
